import styled from "@emotion/styled";

const StyledDiv = styled.div`
  background-image: url(${(props) => props.url});
`;

function ProjectCard({ project }) {
  return (
    <li>
      <StyledDiv className="portfolio-card" url={project.imgUrl}>
        <div className="card-content">
          <p className="card-subtitle">{project.description}</p>

          <h3 className="h3 card-title">{project.title}</h3>
          <p className="card-subtitle2">{project.tools}</p>

          <a href={project.url} className="btn-link">
            <span>{project.type}</span>

            <ion-icon name="arrow-forward"></ion-icon>
          </a>
        </div>
      </StyledDiv>
    </li>
  );
}

export default ProjectCard;
